import React, { useState, useEffect } from 'react';
import axiosInstance from "../../../interceptor/axiosInstance";
import NotificationService from "../../Utils/NotificationService";

const HtmlGuide = () => {
  const [orgCode, setOrgCode] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchOrgDetails = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setOrgCode("YOUR_ORG_CODE");
        return;
      }
      try {
        const response = await axiosInstance.get(`/org/org-details`);
        const data = response.data[0];
        setOrgCode(data.organisation_code);
      } catch (error) {
        console.error('Error fetching organization details:', error);
        setOrgCode("YOUR_ORG_CODE");
      }
    };
    fetchOrgDetails();
  }, []);

  const scriptCode = `
<div id="chat-bot-container"></div>
<script src="https://ezzdesk.com/shared_prompt.js?code=${orgCode}"></script>
  `.trim();

  const handleCopy = () => {
    navigator.clipboard.writeText(scriptCode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }).catch((err) => {
      NotificationService.error('Failed to copy text: ' + err);
    });
  };

  return (
    <div style={{
      padding: '40px',
      maxWidth: '800px',
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
      background: '#ffffff',
      color: '#333',
      lineHeight: '1.6'
    }}>
      <h1 style={{ fontSize: '28px', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
        Adding Ezzdesk Widget to HTML Website
      </h1>
      
      <p style={{ fontSize: '16px', marginBottom: '30px', color: '#555' }}>
        Follow these simple steps to integrate the Ezzdesk chat widget into your HTML website.
      </p>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>1. Copy the installation code</h3>
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '15px' }}>
          Below is your unique widget installation code. Click the "Copy" button to save it to your clipboard.
        </p>
        <div style={{ position: 'relative' }}>
          <pre style={{
            background: '#f4f4f4',
            padding: '20px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            fontFamily: 'Courier New, monospace',
            fontSize: '14px',
            overflowX: 'auto'
          }}>
            {scriptCode}
          </pre>
          <button
            onClick={handleCopy}
            className='btn-color'
            style={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              padding: '6px 16px',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold',
            }}
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>2. Add the widget to your website</h3>
        <ul style={{ fontSize: '15px', color: '#666', paddingLeft: '20px' }}>
          <li style={{ marginBottom: '10px' }}>Open your website's HTML file in your code editor.</li>
          <li style={{ marginBottom: '10px' }}>Paste the installation code into the <code>&lt;body&gt;</code> section of your HTML file.</li>
          <li>For the best experience, paste it just before the closing <code>&lt;/body&gt;</code> tag so it floats at the bottom of the page.</li>
        </ul>
        <img src="/assets/image_aadfc97d.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

      </div>

      <div style={{ background: '#f9f9f9', padding: '20px', borderRadius: '5px', borderLeft: '4px solid #007BFF' }}>
        <h4 style={{ margin: '0 0 10px 0', fontSize: '16px' }}>Need Help?</h4>
        <p style={{ margin: 0, fontSize: '14px', color: '#555' }}>
          If you encounter any issues while installing the widget, feel free to contact our support team.
        </p>
      </div>
    </div>
  );
};

export default HtmlGuide;
